import { inject, Pipe, PipeTransform } from '@angular/core'
import { TextTransformerService } from '@shared/services/text-transformer.service'

@Pipe({
	name: 'compactNumber',
	pure: false,
})
export class CompactNumberPipe implements PipeTransform {
	private readonly _textTransformerService: TextTransformerService =
		inject<TextTransformerService>(TextTransformerService)

	transform(value: number | string | null | undefined): string {
		return this._textTransformerService.toCompactNumber(value)
	}
}
